export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00132.d9050df5.png";